import IconFavoriteDisable from '@/components/assets/icon_favorite_disable.svg'
import IconFavoriteEnable from '@/components/assets/icon_favorite_enable.svg'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

function formatLikesCount(count: number) {
  if (count <= 0) {
    return undefined
  }

  const table = [
    { limit: 1_000_000, unitKey: 'million' },
    { limit: 1_000, unitKey: 'kilo' },
    { limit: 1, unitKey: '' },
  ]

  for (const row of table) {
    if (count >= row.limit) {
      let num = count / row.limit

      num = Math.floor(num * 10) / 10

      let result = num.toString()

      if (result.length >= 5 && result.includes('.')) {
        result = Math.floor(num).toString()
      }

      return { count: result, unitKey: row.unitKey }
    }
  }
}

function CommentLikeButton({
  isLiked,
  handleClick,
  likeCount,
}: {
  isLiked: boolean
  handleClick: () => void
  likeCount: number
}) {
  const t = useTranslations()
  const likesCount = useMemo(() => formatLikesCount(likeCount), [likeCount])
  return (
    <div className="flex h-8.5 w-fit min-w-[80px] items-center">
      <button onClick={(prev) => !prev}>
        <div
          className="group relative"
          style={{ width: '34px', height: '34px' }}
          onClick={handleClick}
        >
          <IconFavoriteEnable
            className={cn(
              'group-hover:[&>path]:fill-vive-white absolute inset-0 m-auto group-hover:opacity-100',
              isLiked ? 'opacity-100' : 'opacity-0',
            )}
            width={20}
            height={20}
          />
          <IconFavoriteDisable
            className={cn(
              'absolute inset-0 m-auto group-hover:opacity-0',
              isLiked ? 'opacity-0' : 'opacity-100',
            )}
            width={20}
            height={20}
          />
        </div>
      </button>
      {likesCount && (
        <span className="flx-col buttonS-omni-styles flex items-center leading-4.5">
          {likesCount.count}
          {likesCount.unitKey && t(`comment-block.likes-unit.${likesCount.unitKey}`)}
        </span>
      )}
    </div>
  )
}

export default CommentLikeButton
